<template>
    <app-dialog v-if="isActive" v-model="isActive" size="x-large" :persistent="false" :title="heading" :text="text">
        <app-item-group
            v-model="selected"
            :items="advisers"
            :multiple="multiple"
            class="text-left mb-5 mx-4"
            :class="{ 'mt-4': !text }"
        />

        <template #actions>
            <v-spacer />
            <app-button :text="$t('cancel')" secondary @click="isActive = false" />
            <app-button :text="submitButtonText" :disabled="!hasSelected" class="ml-2" @click="onSubmit" />
        </template>
    </app-dialog>
</template>

<script>
import { Investor } from '@/models';

export default {
    name: 'InvestorAdviserSelector',
    components: {
        AppDialog: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppDialog'
            ),
        AppItemGroup: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppItemGroup'
            )
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        investorId: {
            type: String,
            required: true
        },
        heading: {
            type: String,
            default: 'Select Adviser'
        },
        text: {
            type: String,
            default: null
        },
        submitButtonText: {
            type: String,
            default: 'Submit'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        getItemText: {
            type: Function,
            default: () => null
        }
    },
    data: () => ({
        investor: new Investor(),
        selected: null
    }),
    computed: {
        isActive: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        hasSelected() {
            if (this.multiple) {
                return this.selected && this.selected.length > 0;
            }

            return this.selected;
        },
        advisers() {
            if (!this.investor.id) {
                return [];
            }
            return this.investor.adviser_accounts.map(aa => ({
                id: aa.adviser.id,
                heading: aa.adviser.name,
                text: this.getItemText(aa)
            }));
        }
    },
    watch: {
        investorId() {
            this.setup();
        },
        multiple() {
            this.selected = this.multiple ? [] : null;
        }
    },
    methods: {
        async setup() {
            try {
                if (this.investorId) {
                    this.investor = await Investor.$get(this.investorId);
                    this.investor = await this.investor.$hydrateAdviserAccounts();
                } else {
                    this.investor = new Investor();
                }
            } catch (error) {
                this.handleError(error, this.setup);
            }
        },
        async onSubmit() {
            this.$emit('submit', this.selected);

            this.isActive = false;
        }
    }
};
</script>
